import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data/site";
import { Reveal, Magnetic } from "./primitives";

const cols = [
  { h: "Explore", links: [["Home", "/"], ["About", "/about"], ["Solutions", "/solutions"], ["Products", "/products"], ["Our Network", "/network"], ["Work", "/work"], ["Sustainability", "/sustainability"], ["Insights", "/insights"]] },
  { h: "Business", links: [["Corporate Merchandise", "/solutions"], ["Gifting", "/solutions"], ["Employee Kits", "/solutions"], ["Partner Engagement", "/solutions"], ["Events", "/solutions"], ["Vouchers", "/network"], ["Sustainable Products", "/sustainability"]] },
];

const Footer = () => (
  <footer data-testid="footer" className="bg-[#111111] text-white relative overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      {/* Big CTA */}
      <div className="py-20 md:py-28 border-b border-white/10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-white/50 mb-6">Let's build something</p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-8xl font-medium tracking-tighter leading-[0.92]">
            Tell us what you need.<br />
            <span className="text-[#f4b41a]">We'll take care of the rest.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Magnetic>
              <Link to="/inquire" data-testid="footer-inquire-cta"
                className="group inline-flex items-center gap-2 rounded-full bg-[#f4b41a] hover:bg-[#d99e12] text-neutral-900 font-semibold px-7 py-4 transition-colors duration-300">
                Inquire Now <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </Link>
            </Magnetic>
            <a href={`mailto:${CONTACT.email}`} className="text-white/70 hover:text-white link-underline">{CONTACT.email}</a>
          </div>
        </Reveal>
      </div>

      {/* Columns */}
      <div className="py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <img src="/brand/vetas-logo.png" alt="VETAS" className="h-7 w-auto brightness-0 invert mb-5" />
          <p className="text-sm text-white/60 leading-relaxed max-w-xs">
            {CONTACT.positioning} A single partner for corporate merchandise, gifting, rewards and engagement — delivered pan-India.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.h}>
            <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">{c.h}</p>
            <ul className="space-y-2.5">
              {c.links.map(([l, to]) => (
                <li key={l}><Link to={to} className="text-sm text-white/70 hover:text-[#f4b41a] transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Contact</p>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><a href={`mailto:${CONTACT.email}`} className="hover:text-[#f4b41a]">{CONTACT.email}</a></li>
            {CONTACT.phones.map((p) => (
              <li key={p}><a href={`tel:+91${p}`} className="hover:text-[#f4b41a]">+91 {p}</a></li>
            ))}
            <li><Link to="/contact" className="hover:text-[#f4b41a]">Contact Page →</Link></li>
          </ul>
        </div>
      </div>

      <div className="py-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
        <span>© {new Date().getFullYear()} VETAS. All rights reserved.</span>
        <span>Corporate Solutions · Pan-India Delivery</span>
      </div>
    </div>
  </footer>
);

export default Footer;
